import { render } from "./settingsEditorCog.vue?vue&type=template&id=82e3e992"
import script from "./settingsEditorCog.vue?vue&type=script&lang=js"
export * from "./settingsEditorCog.vue?vue&type=script&lang=js"

import "./settingsEditorCog.vue?vue&type=style&index=0&id=82e3e992&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__